// Logo asset URLs (uploaded by client)
export const LOGO_DARK = "https://customer-assets.emergentagent.com/job_foot-health-pro-2/artifacts/0dnqkey9_IMG_7187.png";
export const LOGO_PURPLE = "https://customer-assets.emergentagent.com/job_foot-health-pro-2/artifacts/l53nyhlc_IMG_4237.png";
